// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Combos_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /so/combos/salvar (controllers/so/combos.php::salvar).
 *
 * Cria (sem so_combo_id) ou atualiza um combo do catalogo GLOBAL. So o Full.
 *   - so_combo_name, so_combo_service_id, so_combo_priority_id,
 *     so_combo_quantity (pares, > 0): OBRIGATORIOS
 *   - so_combo_validity_days: opcional, null = sem validade, senao > 0
 *   - so_combo_active: opcional, 0|1 (default 1 na criacao)
 */
import { registerContract } from './validate'

export interface Combos_SalvarInput {
so_combo_name: string
so_combo_service_id: number
so_combo_priority_id: number
so_combo_quantity: number
so_combo_id?: number
so_combo_validity_days?: number
so_combo_active?: number
}

registerContract('Combos_SalvarInput', {
  so_combo_name:          { type: 'string',  required: true },
  so_combo_service_id:    { type: 'number',  required: true },
  so_combo_priority_id:   { type: 'number',  required: true },
  so_combo_quantity:      { type: 'number',  required: true },
  so_combo_id:            { type: 'number',  required: false },
  so_combo_validity_days: { type: 'number',  required: false },
  so_combo_active:        { type: 'number',  required: false },
})
